<template>

    <section class="highlight-brands row">
        <div
            class="col-md-4"
            v-for="highlightBrand in highlightBrands"
        >
            <img
                :src="require('../../../sass/sustainableclothing/img/homepage/' + highlightBrand.img_src).default"
                :alt="highlightBrand.name"
            />
            <div>
                <div>
                    <h2 v-html="highlightBrand.name" />
                    <p v-html="lang('homepage.highlight-brands.discover', {'%brand%':highlightBrand.name})"></p>
                    <inertia-link
                        :href="route('products.brand-products', {brand_slug:highlightBrand.brand_slug})"
                        v-text="lang('homepage.highlight-brands.explore')"
                    />
                </div>
            </div>
        </div>
    </section>

</template>

<script>

export default {

    computed: {
        highlightBrands() {
            return [
                {
                    name: 'Native Spirit',
                    brand_slug: 'native-spirit',
                    img_src: 'native-spirit.jpg',
                },
                {
                    name: 'Kariban',
                    brand_slug: 'kariban',
                    img_src: 'kariban.jpg',
                },
/*                {
                    name: 'Stanley/&#8203;Stella',
                    brand_slug: 'stanleystella',
                    img_src: 'stanleystella.jpg',
                },*/
                {
                    name: 'iqoniq',
                    brand_slug: 'iqoniq',
                    img_src: 'iqoniq.jpg',
                },
            ];
        },
    },

    name:'HomepageHighlightBrands',

}

</script>
